import { FormSettingsType } from '../components/Form';
import * as yup from 'yup';

const validationSchema = yup.object().shape({
    code: yup.string()
        .min(3, 'MINLENGTH')
        .max(50, 'MAXLENGTH')
        .matches(/^[a-zA-Z0-9]*$/, 'DISTRIBUTOR_CODE_INVALID')
        .required('DISTRIBUTOR_CODE_REQUIRED'),
    name: yup.string()
        .required('REQUIRED')
        .min(3, 'MINLENGTH')
        .max(80, 'MAXLENGTH')
})

export const UnitSearchForm: FormSettingsType = {
    submitOnKeyEnter: true,
    fields: [
        {
            type: 'search',
            name: 'unitsSearch',
            placeholder: 'form.placeholders.auditsSearch',
            addorn: {
                rightIcon: 'search',
            },
        },
    ],
};

export const UnitForm: FormSettingsType = {
    validationSchema: validationSchema,
    fields: [    
        {
            type: 'text',
            className: 'hidden',
            name: 'id',
            label: '',
        },  
        
        {
            type: 'text',
            name: 'name',
            label: 'form.labels.name',
            maxLength: 80,
        },
        {
            type: 'text',
            name: 'code',
            label: 'form.labels.code',
            maxLength: 50,
        },
    ],
};
